import PsListPageMainArea from './PsListPageMainArea';

/**
 * PS（更新履歴一覧・改廃案一覧・確認申請・承認申請）親画面
 */
function PsListPage() {
  return <PsListPageMainArea />;
}

export default PsListPage;
